import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { copy } from "shared/assets";

import { DeleteModal } from "shared/components";
import { addTemporaryToast } from "shared/components/Toast";
import { IAPIState, IStatus } from "shared/types";
import { dataMetaSelector, revokeEditorInvite } from "Venues/state";
import { IEditorInvite, VENUE_ACTIONS } from "Venues/types";
import { useClearActionMetaOnUnMount } from "Venues/utils";

const { revoke } = copy.venueEditors;

interface RevokeEditorModalProps {
  venueId: string;
  invite: IEditorInvite;
  handleClose: () => void;
}

export const RevokeEditorModal: FC<RevokeEditorModalProps> = ({
  venueId,
  invite: { id: inviteId, email },
  handleClose,
}) => {
  const dispatch = useDispatch();
  const { api: apiMeta } = useSelector(
    dataMetaSelector(VENUE_ACTIONS.revokeEditorInvite)
  );

  useClearActionMetaOnUnMount(VENUE_ACTIONS.revokeEditorInvite);

  const handleRevoke = () => {
    dispatch(revokeEditorInvite({ inviteId, venueId }));
  };

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      dispatch(
        addTemporaryToast({ status: IStatus.success, message: revoke.success })
      );
      handleClose();
    }
  }, [apiMeta?.status, dispatch, handleClose]);

  return (
    <DeleteModal
      handleClose={handleClose}
      handleDelete={handleRevoke}
      apiMeta={apiMeta}
      name={email}
      customButtonCopy={revoke.button}
      customDeleteCopy={revoke.message}
    />
  );
};
